// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-user {
  color: var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));
  transition: color 0.15s linear;
}

ion-list {
  height: calc(100% - 57px);
  overflow-y: auto;
}

ion-thumbnail {
  font-size: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/list-selectable/list-users/list-users.component.scss"],"names":[],"mappings":"AACA;EACI,mEAAA;EACA,8BAAA;AAAJ;;AAGE;EACE,yBAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAAJ","sourcesContent":["\n.icon-user{\n    color: var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));\n    transition: color .15s linear;\n  }\n  \n  ion-list {\n    height: calc(100% - 57px);\n    overflow-y: auto;\n  }\n  \n  ion-thumbnail {\n    font-size: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
